import { render, staticRenderFns } from "./EditPrizeModal.vue?vue&type=template&id=c332f2d2"
import script from "./EditPrizeModal.vue?vue&type=script&lang=js"
export * from "./EditPrizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports